<template>
  <div class="vi-header" v-if="hasUserContext">
    <div id="headerweb" class="web wow web-fadeIn">
      <nav role='navigation' class="menu">
        <div class="web-logo">
          <h1>
            <router-link to="/">
    

            <svg width="200px" height="46px" viewBox="0 0 249 59" version="1.1" xmlns:xlink="http://www.w3.org/1999/xlink" xmlns="http://www.w3.org/2000/svg">
              <defs>
                <path d="M0 0L61 0L61 58L0 58L0 0Z" id="path_1" />
                <clipPath id="mask_1">
                  <use xlink:href="#path_1" />
                </clipPath>
              </defs>
              <g id="Group-4" transform="translate(0.5 0.5)">
                <g id="logo_60">
                  <path d="M0 0L61 0L61 58L0 58L0 0Z" id="Background" fill="none" fill-rule="evenodd" stroke="none" />
                  <g clip-path="url(#mask_1)">
                    <g id="Group-3-Copy-2" transform="translate(0.5 0.5)">
                      <path d="M15.7878 52.4287L15.9254 52.169L17.9423 53.3327C17.9959 53.3636 18.0479 53.397 18.0982 53.4329C18.1486 53.4688 18.1972 53.507 18.2439 53.5476C18.2906 53.5882 18.3353 53.6309 18.3779 53.6757C18.4205 53.7206 18.4609 53.7674 18.499 53.8161C18.5371 53.8648 18.5728 53.9153 18.6061 53.9674C18.6394 54.0196 18.6701 54.0732 18.6983 54.1283C18.7264 54.1834 18.7518 54.2397 18.7746 54.2973C18.7973 54.3548 18.8172 54.4133 18.8344 54.4727C18.8515 54.5322 18.8657 54.5923 18.8771 54.6531C18.8884 54.714 18.8969 54.7752 18.9023 54.8368C18.9078 54.8984 18.9103 54.9602 18.9099 55.022C18.9094 55.0839 18.906 55.1456 18.8997 55.2072C18.8933 55.2687 18.884 55.3298 18.8718 55.3904C18.8595 55.4511 18.8444 55.511 18.8264 55.5702C18.8085 55.6294 18.7877 55.6876 18.7641 55.7448C18.7406 55.802 18.7143 55.858 18.6854 55.9127L18.6845 55.9144C18.6562 55.9678 18.6254 56.0197 18.5919 56.07C18.5585 56.1203 18.5226 56.1688 18.4843 56.2156C18.446 56.2623 18.4055 56.307 18.3627 56.3496C18.3199 56.3923 18.2751 56.4327 18.2283 56.4709C18.1815 56.5091 18.1329 56.5449 18.0825 56.5782C18.0321 56.6115 17.9802 56.6422 17.9267 56.6703C17.8732 56.6985 17.8185 56.7239 17.7625 56.7465C17.7065 56.7691 17.6495 56.7889 17.5915 56.8059C17.5335 56.8228 17.4748 56.8368 17.4154 56.8479C17.356 56.8589 17.2962 56.867 17.236 56.8721C17.1758 56.8772 17.1155 56.8792 17.0551 56.8783C16.9947 56.8773 16.9345 56.8734 16.8745 56.8664C16.8145 56.8594 16.7549 56.8495 16.6959 56.8365C16.6369 56.8236 16.5787 56.8077 16.5213 56.789C16.4638 56.7702 16.4075 56.7486 16.3522 56.7242C16.297 56.6998 16.243 56.6727 16.1905 56.6429L14.0154 55.4098L14.1397 55.2919C14.2224 55.2134 14.2915 55.1244 14.3469 55.0247L15.7109 52.5703C15.737 52.5234 15.7626 52.4762 15.7878 52.4288L15.7878 52.4287L15.7878 52.4287Z" id="Rectangle-4" fill="#2954a2" fill-rule="evenodd" stroke="none" />
                      <path d="M44.1909 52.4288L44.0532 52.169L42.0363 53.3327C41.9827 53.3636 41.9307 53.397 41.8804 53.4329C41.83 53.4688 41.7814 53.507 41.7347 53.5476C41.688 53.5882 41.6433 53.6309 41.6007 53.6757C41.5581 53.7206 41.5177 53.7674 41.4796 53.8161C41.4415 53.8648 41.4058 53.9153 41.3725 53.9674C41.3392 54.0196 41.3085 54.0732 41.2803 54.1283C41.2522 54.1834 41.2268 54.2397 41.204 54.2972C41.1813 54.3548 41.1614 54.4133 41.1442 54.4727C41.1271 54.5322 41.1129 54.5923 41.1015 54.6531C41.0902 54.714 41.0818 54.7752 41.0763 54.8368C41.0708 54.8984 41.0683 54.9602 41.0687 55.022C41.0692 55.0839 41.0726 55.1456 41.079 55.2072C41.0853 55.2687 41.0946 55.3298 41.1068 55.3904C41.1191 55.4511 41.1342 55.511 41.1521 55.5702C41.1701 55.6294 41.1909 55.6876 41.2145 55.7448C41.238 55.802 41.2643 55.858 41.2932 55.9127L41.2941 55.9144C41.3224 55.9678 41.3532 56.0197 41.3867 56.07C41.4201 56.1203 41.456 56.1688 41.4943 56.2156C41.5326 56.2623 41.5731 56.307 41.6159 56.3496C41.6587 56.3923 41.7035 56.4327 41.7503 56.4709C41.7971 56.5091 41.8457 56.5449 41.8961 56.5782C41.9465 56.6115 41.9984 56.6422 42.0519 56.6703C42.1054 56.6985 42.1601 56.7238 42.2161 56.7465C42.2721 56.7691 42.3291 56.7889 42.3871 56.8059C42.4451 56.8228 42.5038 56.8368 42.5632 56.8479C42.6226 56.8589 42.6824 56.867 42.7426 56.8721C42.8028 56.8772 42.8631 56.8792 42.9235 56.8783C42.9839 56.8773 43.0441 56.8734 43.1041 56.8664C43.1642 56.8594 43.2237 56.8495 43.2827 56.8365C43.3417 56.8236 43.3999 56.8077 43.4573 56.789C43.5148 56.7702 43.5711 56.7486 43.6264 56.7242C43.6816 56.6998 43.7356 56.6727 43.7881 56.6429L45.9632 55.4098L45.8389 55.2919C45.7562 55.2134 45.6871 55.1244 45.6317 55.0247L44.2677 52.5703C44.2416 52.5234 44.216 52.4762 44.1909 52.4288L44.1909 52.4288L44.1909 52.4288Z" id="Rectangle-4-Copy" fill="#2954a2" fill-rule="evenodd" stroke="none" />
                      <path d="M0 30C0 13.4315 13.4315 0 30 0C46.5685 0 60 13.4315 60 30C60 41.6378 53.3734 51.7278 43.6875 56.7027L43.6875 52.4034C51.2224 47.7901 56.25 39.4822 56.25 30C56.25 15.5025 44.4975 3.75 30 3.75C15.5025 3.75 3.75 15.5025 3.75 30C3.75 39.4822 8.7776 47.7901 16.3125 52.4034L16.3125 56.7027C6.62664 51.7278 0 41.6378 0 30L0 30Z" id="Group-Difference" fill="#2954a2" fill-rule="evenodd" stroke="none" />
                      <g id="lens" transform="translate(23.625 13.875)">
                        <path d="M13.3156 11.1499L13.3167 11.1483C13.3519 11.098 13.3895 11.0496 13.4295 11.003C13.4694 10.9564 13.5116 10.9119 13.5559 10.8694C13.6003 10.827 13.6466 10.7868 13.6948 10.7489C13.7431 10.7111 13.7931 10.6756 13.8449 10.6426C13.8967 10.6097 13.9499 10.5793 14.0047 10.5516C14.0594 10.5238 14.1154 10.4988 14.1726 10.4766C14.2298 10.4543 14.288 10.4349 14.3471 10.4184C14.4062 10.4019 14.466 10.3883 14.5264 10.3776C14.5868 10.367 14.6477 10.3593 14.7089 10.3546C14.7701 10.3499 14.8313 10.3483 14.8927 10.3496C14.9541 10.3509 15.0152 10.3553 15.0761 10.3626C15.1371 10.37 15.1975 10.3803 15.2574 10.3936C15.3173 10.4069 15.3765 10.423 15.4348 10.4421C15.4931 10.4612 15.5504 10.4831 15.6066 10.5079C15.6627 10.5326 15.7176 10.56 15.7711 10.5901C15.8245 10.6202 15.8764 10.6529 15.9267 10.6881L23.3007 15.8514C23.351 15.8866 23.3994 15.9242 23.446 15.9642C23.4926 16.0041 23.5371 16.0463 23.5795 16.0906C23.622 16.1349 23.6621 16.1812 23.7 16.2295C23.7379 16.2778 23.7733 16.3278 23.8063 16.3796C23.8393 16.4313 23.8697 16.4846 23.8974 16.5394C23.9252 16.5941 23.9501 16.6501 23.9724 16.7073C23.9946 16.7645 24.0141 16.8227 24.0306 16.8818C24.0471 16.9409 24.0607 17.0006 24.0713 17.0611C24.082 17.1215 24.0897 17.1823 24.0943 17.2435C24.099 17.3047 24.1007 17.366 24.0994 17.4274C24.098 17.4887 24.0937 17.5499 24.0863 17.6108C24.079 17.6717 24.0687 17.7322 24.0554 17.7921C24.0421 17.852 24.0259 17.9112 24.0068 17.9695C23.9877 18.0278 23.9658 18.085 23.9411 18.1412C23.9164 18.1974 23.889 18.2523 23.8589 18.3057C23.8288 18.3592 23.7961 18.4111 23.7609 18.4614L23.7598 18.463C23.7246 18.5133 23.687 18.5617 23.647 18.6083C23.6071 18.6549 23.5649 18.6994 23.5206 18.7418C23.4762 18.7843 23.4299 18.8244 23.3816 18.8623C23.3334 18.9002 23.2834 18.9357 23.2316 18.9687C23.1798 19.0016 23.1265 19.032 23.0718 19.0597C23.017 19.0875 22.9611 19.1125 22.9039 19.1347C22.8467 19.157 22.7885 19.1763 22.7294 19.1929C22.6703 19.2094 22.6105 19.223 22.5501 19.2337C22.4896 19.2443 22.4288 19.252 22.3677 19.2567C22.3064 19.2614 22.2451 19.263 22.1838 19.2617C22.1224 19.2603 22.0613 19.256 22.0003 19.2487C21.9394 19.2413 21.879 19.231 21.819 19.2177C21.7591 19.2044 21.7 19.1882 21.6417 19.1691C21.5834 19.1501 21.5261 19.1281 21.4699 19.1034C21.4137 19.0787 21.3589 19.0513 21.3054 19.0212C21.252 18.9911 21.2001 18.9584 21.1498 18.9232L13.7758 13.7599C13.7255 13.7247 13.6771 13.6871 13.6305 13.6471C13.5839 13.6072 13.5394 13.565 13.497 13.5207C13.4545 13.4764 13.4143 13.43 13.3765 13.3818C13.3386 13.3335 13.3031 13.2835 13.2701 13.2317C13.2372 13.1799 13.2068 13.1267 13.1791 13.0719C13.1513 13.0172 13.1263 12.9612 13.1041 12.904C13.0818 12.8468 13.0624 12.7886 13.0459 12.7295C13.0294 12.6704 13.0158 12.6107 13.0051 12.5502C12.9945 12.4898 12.9868 12.4289 12.9821 12.3677C12.9774 12.3065 12.9758 12.2453 12.9771 12.1839C12.9785 12.1225 12.9828 12.0614 12.9901 12.0005C12.9975 11.9395 13.0078 11.8791 13.0211 11.8192C13.0344 11.7593 13.0506 11.7001 13.0697 11.6418C13.0887 11.5835 13.1107 11.5262 13.1354 11.47C13.1601 11.4139 13.1875 11.359 13.2176 11.3055C13.2477 11.2521 13.2804 11.2002 13.3156 11.1499L13.3156 11.1499L13.3156 11.1499Z" id="Rectangle-3" fill="#2954a2" fill-rule="evenodd" stroke="none" />
                        <path d="M6.75 0C3.02208 0 0 3.02208 0 6.75C0 10.4779 3.02208 13.5 6.75 13.5C10.4779 13.5 13.5 10.4779 13.5 6.75C13.5 3.02208 10.4779 0 6.75 0L6.75 0ZM6.75 2.25C4.26472 2.25 2.25 4.26472 2.25 6.75C2.25 9.23528 4.26472 11.25 6.75 11.25C9.23528 11.25 11.25 9.23528 11.25 6.75C11.25 4.26472 9.23528 2.25 6.75 2.25L6.75 2.25Z" id="Ellipse-Difference" fill="#2954a2" fill-rule="evenodd" stroke="none" />
                      </g>
                      <g id="v" transform="translate(13.554237 21.646685)">
                        <path d="M0.938734 0.25107L0.937002 0.252069C0.883851 0.282757 0.832329 0.315977 0.782434 0.351728C0.732546 0.38748 0.68453 0.425587 0.638387 0.466055C0.592239 0.506523 0.54819 0.549154 0.506239 0.593948C0.464283 0.638742 0.424623 0.685488 0.387257 0.734182C0.349892 0.782877 0.315004 0.833284 0.282595 0.885405C0.250187 0.937523 0.220407 0.991104 0.193261 1.04615C0.166115 1.1012 0.141731 1.15744 0.120115 1.21488C0.0984936 1.27233 0.0797405 1.33069 0.0638552 1.38997C0.0479689 1.44926 0.0350285 1.50918 0.025033 1.56973C0.0150318 1.63029 0.00802422 1.69119 0.00400734 1.75244C-1.90735e-06 1.81368 -0.00100231 1.87497 0.00100422 1.93632C0.00301456 1.99766 0.00802422 2.05876 0.0160332 2.11961C0.0240459 2.18046 0.0350189 2.24077 0.048954 2.30055C0.0628948 2.36032 0.0797272 2.41926 0.0994549 2.47738C0.119186 2.5355 0.141714 2.59251 0.167041 2.64842C0.192373 2.70432 0.220383 2.75885 0.25107 2.812L14.8771 28.145C14.9078 28.1982 14.941 28.2497 14.9767 28.2996C15.0125 28.3494 15.0506 28.3975 15.091 28.4436C15.1315 28.4897 15.1741 28.5338 15.2189 28.5758C15.2637 28.6177 15.3105 28.6574 15.3592 28.6948C15.4079 28.7321 15.4583 28.767 15.5104 28.7994C15.5625 28.8318 15.6161 28.8616 15.6711 28.8887C15.7262 28.9159 15.7824 28.9403 15.8399 28.9619C15.8973 28.9835 15.9557 29.0022 16.015 29.0181C16.0742 29.034 16.1342 29.0469 16.1947 29.0569C16.2553 29.0669 16.3162 29.074 16.3774 29.078C16.4387 29.082 16.5 29.083 16.5613 29.081C16.6226 29.079 16.6838 29.074 16.7446 29.066C16.8055 29.058 16.8658 29.047 16.9255 29.033C16.9853 29.0191 17.0442 29.0022 17.1024 28.9825C17.1605 28.9628 17.2175 28.9403 17.2734 28.915C17.3293 28.8896 17.3838 28.8616 17.437 28.8309L17.4387 28.8299C17.4919 28.7992 17.5434 28.766 17.5933 28.7303C17.6432 28.6946 17.6912 28.6564 17.7373 28.6159C17.7835 28.5755 17.8275 28.5328 17.8695 28.488C17.9114 28.4433 17.9511 28.3965 17.9885 28.3478C18.0258 28.2991 18.0607 28.2487 18.0931 28.1966C18.1255 28.1444 18.1553 28.0909 18.1825 28.0359C18.2096 27.9808 18.234 27.9245 18.2556 27.8671C18.2772 27.8096 18.296 27.7513 18.3119 27.692C18.3277 27.6327 18.3407 27.5728 18.3507 27.5123C18.3607 27.4517 18.3677 27.3908 18.3717 27.3295C18.3757 27.2683 18.3767 27.207 18.3747 27.1457C18.3727 27.0843 18.3677 27.0232 18.3597 26.9624C18.3517 26.9016 18.3407 26.8412 18.3268 26.7815C18.3128 26.7217 18.296 26.6627 18.2763 26.6046C18.2565 26.5465 18.234 26.4895 18.2087 26.4336C18.1834 26.3777 18.1554 26.3232 18.1247 26.27L3.49867 0.937002C3.46798 0.883852 3.43476 0.832333 3.39901 0.782444C3.36326 0.732553 3.32515 0.684536 3.28468 0.638388C3.24421 0.592245 3.20158 0.548197 3.15679 0.506241C3.11199 0.464283 3.06524 0.424623 3.01655 0.387257C2.96786 0.349897 2.91746 0.31501 2.86533 0.282597C2.81321 0.250187 2.75963 0.220407 2.70458 0.193262C2.64954 0.166117 2.59329 0.141735 2.53585 0.120113C2.47841 0.0984936 2.42005 0.0797424 2.36076 0.0638561C2.30148 0.0479717 2.24155 0.0350304 2.181 0.025032C2.12044 0.0150337 2.05954 0.00802803 1.9983 0.00401497C1.93705 -1.90735e-06 1.87576 -0.00100327 1.81442 0.00100517C1.75307 0.00301552 1.69198 0.00802422 1.63113 0.0160332C1.57028 0.024044 1.50996 0.0350189 1.45019 0.0489578C1.39042 0.0628948 1.33147 0.0797253 1.27336 0.0994549C1.21524 0.119184 1.15822 0.141714 1.10232 0.167044C1.04641 0.192375 0.991885 0.220383 0.938734 0.25107L0.938734 0.25107L0.938734 0.25107Z" id="Rectangle-2-Copy" fill="#2954a2" fill-rule="evenodd" stroke="none" />
                        <path d="M32.512 0.25284L32.5137 0.253839C32.5669 0.284527 32.6184 0.317745 32.6683 0.353493C32.7182 0.389244 32.7662 0.427355 32.8123 0.467825C32.8585 0.508289 32.9025 0.55092 32.9445 0.595718C32.9864 0.640512 33.0261 0.687258 33.0635 0.735952C33.1008 0.784643 33.1357 0.835051 33.1681 0.887175C33.2005 0.939293 33.2303 0.992874 33.2575 1.04792C33.2846 1.10297 33.309 1.15921 33.3306 1.21665C33.3522 1.2741 33.371 1.33246 33.3869 1.39174C33.4028 1.45103 33.4157 1.51095 33.4257 1.5715C33.4357 1.63206 33.4427 1.69296 33.4467 1.7542C33.4507 1.81545 33.4517 1.87674 33.4497 1.93809C33.4477 1.99943 33.4427 2.06053 33.4347 2.12138C33.4267 2.18223 33.4157 2.24254 33.4018 2.30232C33.3878 2.36209 33.371 2.42103 33.3513 2.47915C33.3315 2.53727 33.309 2.59428 33.2837 2.65019C33.2584 2.70609 33.2303 2.76062 33.1997 2.81377L18.5737 28.1468C18.543 28.1999 18.5097 28.2515 18.474 28.3013C18.4383 28.3512 18.4002 28.3992 18.3597 28.4454C18.3192 28.4915 18.2766 28.5356 18.2318 28.5775C18.187 28.6195 18.1402 28.6592 18.0915 28.6965C18.0429 28.7339 17.9925 28.7688 17.9403 28.8012C17.8882 28.8336 17.8346 28.8633 17.7796 28.8905C17.7245 28.9176 17.6683 28.942 17.6108 28.9637C17.5534 28.9853 17.4951 29.004 17.4358 29.0199C17.3765 29.0358 17.3166 29.0487 17.256 29.0587C17.1955 29.0687 17.1346 29.0757 17.0733 29.0798C17.0121 29.0838 16.9508 29.0847 16.8894 29.0827C16.8281 29.0807 16.767 29.0757 16.7061 29.0678C16.6453 29.0597 16.585 29.0487 16.5252 29.0348C16.4654 29.0208 16.4065 29.004 16.3484 28.9843C16.2902 28.9646 16.2332 28.9421 16.1773 28.9167C16.1214 28.8914 16.0669 28.8634 16.0137 28.8327L16.012 28.8317C15.9589 28.801 15.9073 28.7678 15.8574 28.7321C15.8075 28.6963 15.7595 28.6582 15.7134 28.6177C15.6673 28.5772 15.6232 28.5346 15.5812 28.4898C15.5393 28.445 15.4996 28.3983 15.4622 28.3496C15.4249 28.3009 15.39 28.2505 15.3576 28.1983C15.3252 28.1462 15.2954 28.0926 15.2682 28.0376C15.2411 27.9826 15.2167 27.9263 15.1951 27.8689C15.1735 27.8114 15.1548 27.7531 15.1389 27.6938C15.123 27.6345 15.11 27.5746 15.1 27.5141C15.09 27.4535 15.083 27.3926 15.079 27.3313C15.075 27.2701 15.074 27.2088 15.076 27.1474C15.078 27.0861 15.083 27.025 15.091 26.9642C15.099 26.9033 15.11 26.843 15.124 26.7832C15.1379 26.7235 15.1547 26.6645 15.1745 26.6064C15.1942 26.5483 15.2167 26.4913 15.242 26.4354C15.2674 26.3795 15.2954 26.3249 15.3261 26.2718L29.9521 0.938772C29.9827 0.885622 30.016 0.834103 30.0517 0.784214C30.0875 0.734324 30.1256 0.686306 30.166 0.640156C30.2065 0.594015 30.2491 0.549967 30.2939 0.508009C30.3387 0.466053 30.3855 0.426394 30.4342 0.389027C30.4829 0.351667 30.5333 0.31678 30.5854 0.284367C30.6375 0.251957 30.6911 0.222178 30.7461 0.195032C30.8012 0.167887 30.8574 0.143503 30.9149 0.121883C30.9723 0.100264 31.0307 0.0815125 31.09 0.0656261C31.1493 0.0497417 31.2092 0.0368004 31.2697 0.0268021C31.3303 0.0168037 31.3912 0.00979805 31.4524 0.00578308C31.5137 0.00176811 31.575 0.000766754 31.6363 0.00277519C31.6977 0.00478554 31.7588 0.00979424 31.8196 0.0178032C31.8805 0.0258141 31.9408 0.0367889 32.0005 0.0507278C32.0603 0.0646648 32.1193 0.0814953 32.1774 0.101225C32.2355 0.120955 32.2925 0.143484 32.3484 0.168814C32.4043 0.194145 32.4588 0.222153 32.512 0.25284L32.512 0.25284L32.512 0.25284Z" id="Rectangle-2-Copy-2" fill="#2954a2" fill-rule="evenodd" stroke="none" />
                      </g>
                    </g>
                  </g>
                </g>
                <g id="Vidhyaan" fill="#2954a2" transform="translate(70.5 11.5)">
                  <path d="M33.501 9.48081C33.501 10.8848 32.37 12.0158 30.966 12.0158C29.562 12.0158 28.431 10.8848 28.431 9.48081C28.431 8.07681 29.562 6.94581 30.966 6.94581C32.37 6.94581 33.501 8.07681 33.501 9.48081ZM26.208 7.14081L15.99 33.1538L10.296 33.1538L0.078 7.14081L5.265 7.14081L13.143 28.1618L21.021 7.14081L26.208 7.14081ZM55.653 33.1538L55.653 7.14081L51.558 7.14081L51.558 16.9298C50.076 14.9018 47.892 13.8488 45.513 13.8488C40.677 13.8488 37.167 17.6318 37.167 23.7158C37.167 29.9558 40.716 33.6218 45.513 33.6218C47.97 33.6218 50.115 32.4518 51.558 30.5798L51.558 33.1538L55.653 33.1538ZM77.805 19.8158L77.805 33.1538L73.71 33.1538L73.71 21.2978C73.71 18.3338 72.228 17.4758 69.927 17.4758C67.821 17.4758 66.027 18.7238 65.091 19.9718L65.091 33.1538L60.996 33.1538L60.996 7.14081L65.091 7.14081L65.091 16.8518C66.339 15.3698 68.757 13.8488 71.721 13.8488C75.777 13.8488 77.805 15.9548 77.805 19.8158ZM118.365 20.6348L118.365 33.1538L114.27 33.1538L114.27 31.0868C112.866 32.7248 110.643 33.6218 108.147 33.6218C105.105 33.6218 101.634 31.5158 101.634 27.3818C101.634 23.0138 105.066 21.2198 108.147 21.2198C110.721 21.2198 112.866 22.0388 114.27 23.6378L114.27 20.8298C114.27 18.6458 112.437 17.3198 109.863 17.3198C107.757 17.3198 105.885 18.0998 104.286 19.7378L102.57 16.8908C104.754 14.7848 107.484 13.8488 110.487 13.8488C114.699 13.8488 118.365 15.6038 118.365 20.6348ZM139.308 33.1538L139.308 20.6348C139.308 15.6038 135.642 13.8488 131.43 13.8488C128.427 13.8488 125.697 14.7848 123.513 16.8908L125.229 19.7378C126.828 18.0998 128.7 17.3198 130.806 17.3198C133.38 17.3198 135.213 18.6458 135.213 20.8298L135.213 23.6378C133.809 22.0388 131.664 21.2198 129.09 21.2198C126.009 21.2198 122.577 23.0138 122.577 27.3818C122.577 31.5158 126.048 33.6218 129.09 33.6218C131.586 33.6218 133.809 32.7248 135.213 31.0868L135.213 33.1538L139.308 33.1538ZM161.46 19.8938L161.46 33.1538L157.365 33.1538L157.365 21.3758C157.365 18.4118 155.844 17.4758 153.543 17.4758C151.476 17.4758 149.682 18.7238 148.707 19.9718L148.707 33.1538L144.612 33.1538L144.612 14.3168L148.707 14.3168L148.707 16.8518C149.955 15.3698 152.412 13.8488 155.376 13.8488C159.432 13.8488 161.46 16.0328 161.46 19.8938ZM32.994 14.3168L32.994 33.1538L28.899 33.1538L28.899 14.3168L32.994 14.3168ZM82.329 40.5248C82.875 40.6808 84.045 40.7978 84.63 40.7978C87.555 40.7588 89.778 39.7448 91.065 36.5468L100.152 14.3168L95.784 14.3168L90.285 28.4348L84.786 14.3168L80.379 14.3168L88.14 33.3878L87.204 35.5328C86.658 36.7808 85.8 37.1708 84.474 37.1708C84.006 37.1708 83.343 37.0538 82.914 36.8588L82.329 40.5248ZM46.722 29.9948C43.446 29.9948 41.379 27.3818 41.379 23.7158C41.379 20.0888 43.446 17.4758 46.722 17.4758C48.633 17.4758 50.661 18.6068 51.558 20.0108L51.558 27.4598C50.661 28.8638 48.633 29.9948 46.722 29.9948ZM105.729 27.4208C105.729 29.4878 107.484 30.8138 109.785 30.8138C111.54 30.8138 113.295 30.1508 114.27 28.8638L114.27 25.9778C113.295 24.6908 111.54 24.0278 109.785 24.0278C107.484 24.0278 105.729 25.3928 105.729 27.4208ZM130.728 30.8138C128.427 30.8138 126.672 29.4878 126.672 27.4208C126.672 25.3928 128.427 24.0278 130.728 24.0278C132.483 24.0278 134.238 24.6908 135.213 25.9778L135.213 28.8638C134.238 30.1508 132.483 30.8138 130.728 30.8138Z" />
                </g>
                <g id="Group-3" transform="translate(234 14)">
                  <g id="R" fill="#2954a2" transform="matrix(0.99999994 0 0 0.99999994 2.4310303 1.7155151)">
                    <path d="M1.94055 9.0791L1.94055 1.9209L4.98254 1.9209Q6.13 1.9209 6.65002 2.11377Q7.17004 2.30664 7.48254 2.7998Q7.79504 3.29297 7.79504 3.92773Q7.79504 4.7334 7.32141 5.2583Q6.84777 5.7832 5.90539 5.91992Q6.37414 6.19336 6.67932 6.52051Q6.98449 6.84766 7.50207 7.68262L8.37609 9.0791L6.64758 9.0791L5.60266 7.52148Q5.04602 6.68652 4.84094 6.46924Q4.63586 6.25195 4.40637 6.17139Q4.17688 6.09082 3.67883 6.09082L3.38586 6.09082L3.38586 9.0791L1.94055 9.0791ZM3.38586 4.94824L4.4552 4.94824Q5.49523 4.94824 5.75402 4.86035Q6.01281 4.77246 6.1593 4.55762Q6.30578 4.34277 6.30578 4.02051Q6.30578 3.65918 6.11291 3.43701Q5.92004 3.21484 5.56848 3.15625Q5.3927 3.13184 4.51379 3.13184L3.38586 3.13184L3.38586 4.94824Z" />
                  </g>
                  <path d="M0 7C0 3.13401 3.13401 0 7 0C10.866 0 14 3.13401 14 7C14 10.866 10.866 14 7 14C3.13401 14 0 10.866 0 7Z" id="Ellipse" fill="none" fill-rule="evenodd" stroke="#2954a2" stroke-width="1" />
                </g>
              </g>
            </svg>
               </router-link>
          </h1>
          
        </div>
        <label for="menu">Menu <i class="fa fa-bars"></i></label>
        <input type="checkbox" id="menu">
        <ul style="padding-top: 4px;">
					<li><a href="javascript:void(0)" @click="redirectRoute('/')">Home</a></li>
					
					<li><a href="#whyvidhyaan" @click="redirectRoute('#whyvidhyaan')">Why Vidhyaan</a></li>
          	<li ><a href="javascript:void(0)" class="active" @click="redirectRoute('/pricingView')">Pricing</a></li>
          <!--  v-if="$route.path != '/search-schools'" -->
					<li class="menu-hasdropdown">
            <a >
              <label title="toggle menu" for="services">
                Our Services <i class="fa fa-caret-down"></i>
              </label>
            </a>
            <input type="checkbox" id="services">
            <ul class="menu-dropdown">
              <li><a href="#services"  :style="ourServiceActive && ourServiceActive == 'WEBSITE & ONLINE ADMISSION ENROLLMENT' ? 'background-color: #cbcbd5;' : ''" @click="viewOurServices('/#services','WEBSITE & ONLINE ADMISSION ENROLLMENT')">Website & Online Admission Enrollment</a></li>
              <li><a href="#services" :style="ourServiceActive && ourServiceActive == 'LIST YOUR SCHOOLS ONLINE FOR WIDER REACH' ? 'background-color: #cbcbd5;' : ''" @click="viewOurServices('/#services','LIST YOUR SCHOOLS ONLINE FOR WIDER REACH')">List Your Schools Online for Wider Reach</a></li>
              <li><a href="#services" :style="ourServiceActive && ourServiceActive == 'PARENT PORTAL' ? 'background-color: #cbcbd5;' : ''" @click="viewOurServices('/#services','PARENT PORTAL')">Parent Portal</a></li>
              <li><a href="#services" :style="ourServiceActive && ourServiceActive == 'ADMISSION MANAGEMENT' ? 'background-color: #cbcbd5;' : ''" @click="viewOurServices('/#services','ADMISSION MANAGEMENT')">Admission Management</a></li>
              <li><a href="#services" :style="ourServiceActive && ourServiceActive == 'FEE MANAGEMENT' ? 'background-color: #cbcbd5;' : ''" @click="viewOurServices('/#services','FEE MANAGEMENT')">Fee Management</a></li>
              <li><a href="#services" :style="ourServiceActive && ourServiceActive == 'ALERTS & NOTIFICATIONS' ? 'background-color: #cbcbd5;' : ''" @click="viewOurServices('/#services','ALERTS & NOTIFICATIONS')">Alert & Notification</a></li>

          
            </ul>
          </li>
        
          <li><a href="#aboutus" @click="redirectRoute('#aboutus')">About Us</a></li>
					<li><a href="#contactus" @click="redirectRoute('#contactus')">Contact Us</a></li>
          <li>
       
        <div class="web-header-web-social-links" v-if="$route.path != '/forgotPassword' && $route.path != '/change-password' && $route.path != '/invitaion-accept'">
          
          <div class="dropdown">
            <button
              class="btn web-custbtn web-lgd web-rounded-xl h-100 btn-3 "
              id="regbtnid"
            >
              <span
                ><b-icon
                  icon="pencil-square"
                  style="height:15px;margin-right: 8px;"
                ></b-icon></span
              >Register
            </button>
            <button
              class="btn web-btnsrch web-smd web-rounded-xl h-100 btn-3 pt-2"
              id="regbtnid"
            >
              <b-icon icon="pencil-square" style="height:15px"></b-icon>
            </button>
            <div class="web-dropdown-content wow web-bounceIn">
              <div class="arrow-up"></div>
              <div class="dropmenu">
                <router-link to="/register/school"
                  >School / Institution</router-link
                >
                <router-link to="/register/parent">Parent / Self</router-link>
              </div>
            </div>
          </div>
           <!-- <button
            class="btn web-custbtn web-lgd web-rounded-xl btn-3 h-100"
            @click="navigateRoute('/register/school')"
          >
          <span
                ><b-icon
                  icon="pencil-square"
                  style="height:15px"
                ></b-icon></span
              > Register
          </button> -->
          <button
            class="btn web-btnsrch web-smd web-rounded-xl btn-3 h-100 pt-2"
            @click="navigateRoute('/register/school')"
          >
            <b-icon icon="person"></b-icon>
          </button>
          <button
            class="btn web-custbtn web-lgd web-rounded-xl btn-3 h-100"
            @click="navigateRoute('/login')"
          >
            <span><b-icon icon="person"></b-icon></span> Login
          </button>
          <button
            class="btn web-btnsrch web-smd web-rounded-xl btn-3 h-100 pt-2"
            @click="navigateRoute('/login')"
          >
            <b-icon icon="person"></b-icon>
          </button>
        
        </div>
        </li>
        </ul>
      </nav>
      <div class="container-fluid d-flex align-items-center">
        
        <div class="sidebar" id="mySidebar">
			
				
			</div>

       
      </div>
    </div>
    <div id="web-sidebarOverlay" @click="closeNav()"></div>
    <div id="mySidebar" class="web-sidebar">
      <span href="javascript:void(0)" class="web-closebtn" @click="closeNav()"
        >×</span
      >
      <a href="javascript:void(0);" class="nav-link nav-link-grow-up">Home</a>
      <a href="javascript:void(0);" class="nav-link nav-link-grow-up"
        >Why Vidhyaan</a
      >
      <a href="javascript:void(0);" class="nav-link nav-link-grow-up"
        >Services</a
      >
      <a href="javascript:void(0);" class="nav-link nav-link-grow-up"
        >Community</a
      >
      <a href="javascript:void(0);" class="nav-link nav-link-grow-up"
        >About Us</a
      >
      <a href="javascript:void(0);" class="nav-link nav-link-grow-up"
        >Contact Us</a
      >
    </div>
    <div id="myOverlay" class="web-srchoverlay">
      <span class="web-closebtn" @click="closeSearch()" title="Close web-srchoverlay"
        >×</span
      >
      <div class="web-srchoverlay-content wow web-bounceIn">
        <div class="container-fluid p-0">
          <div class="row m-0 web-overlaypopup no-gutters">
            <div class="col-sm-5">
              <img
                class="mt-3"
                src="../assets/img/search3.jpg"
                alt="School and Teacher Search"
                title="School and Teacher Search"
              />
            </div>
            <div class="col-sm-7 p-3">
              <h4 class="text-left pt-3">I am happy to HELP YOU!!!</h4>
              <div class="wrapper">
                <div class="content">
                  <!-- Tab links -->
                  <div class="tabs">
                    <button
                      class="web-tablinks active"
                      data-search="tpSearchSchool"
                    >
                      <p data-title="tpSearchSchool">Search School</p>
                    </button>
                    <button class="web-tablinks" data-search="tpTeacherJobs">
                      <p data-title="tpTeacherJobs">Teacher Jobs</p>
                    </button>
                  </div>

                  <!-- Tab content -->
                  <div class="web-wrapper_tabcontent">
                    <div id="tpSearchSchool" class="web-tabcontent active">
                      <div class="home-search-form">
                        <div class="form-row">
                          <div class="form-group input-group col-sm-6 pr-md-3">
                            <span class="web-has-float-label">
                              <input
                                type="text"
                                name="sname"
                                v-model="sname"
                                class="form-control web-form-input"
                                placeholder="School Name"
                              />
                              <label for="sname">School Name </label>
                            </span>
                          </div>
                          <div class="form-group input-group col-sm-6 ">
                            <span class="web-has-float-label">
                              <input
                                list="scategory"
                                class="form-control web-form-input"
                                v-model="scategory"
                                name="scategory"
                                placeholder="School Category"
                              />
                              <label for="scategory">School Category</label>
                              <datalist id="scategory">
                                <option value="CBSE">CBSE</option>
                                <option value="International"
                                  >International</option
                                >
                                <option value="ICSE">ICSE</option>
                                <option value="Government">Government</option>
                                <option value="Government Aided"
                                  >Government Aided</option
                                >
                              </datalist>
                            </span>
                          </div>
                        </div>
                        <div class="form-row">
                          <div class="form-group input-group col-sm-12 mt-4">
                            <span class="web-has-float-label">
                              <input
                                list="slocation"
                                class="form-control web-form-input"
                                name="slocation"
                                v-model="slocation"
                                placeholder="Select Location"
                              />
                              <label for="slocation">Select Location</label>
                              <datalist id="slocation">
                                <option value="Chennai">Chennai</option>
                                <option value="Coimbatore">Coimbatore</option>
                              </datalist>
                            </span>
                          </div>
                        </div>
                        <div style="text-align:center">
                          <button
                            type="submit"
                            class="web-custbutton mt-3"
                            @click="submitSearch"
                          >
                            Search
                          </button>

                          <button class="web-cancelbutton mt-3 ml-2" @click="reset">
                            Reset
                          </button>
                        </div>
                        <vi-spinner
                          v-if="viLoader"
                          text="Loading..."
                          textColor="vi-brand-color"
                          class="flex-fill h-100 vi-fs12"
                          style="width: 100%;z-index: 111;top:0;left:0;background-color: rgba(255, 255, 255, 0.5);"
                        />
                      </div>
                    </div>

                    <div id="tpTeacherJobs" class="web-tabcontent">
                      <form action="" method="post" accept-charset="utf-8">
                        <div class="form-row">
                          <div class="form-group input-group col-sm-6 pr-md-3">
                            <span class="web-has-float-label">
                              <input
                                type="text"
                                name="sname"
                                value=""
                                class="form-control web-form-input"
                                id="snameid"
                                placeholder="School Name"
                                required="required"
                              />
                              <label for="snameid"
                                >School Name
                                <span class="required">*</span></label
                              >
                            </span>
                          </div>
                          <div class="form-group input-group col-sm-6 ">
                            <span class="web-has-float-label">
                              <input
                                list="schcate"
                                value=""
                                class="form-control web-form-input"
                                id="schcateid"
                                placeholder="School Category"
                                required="required"
                              />
                              <label for="schcateid"
                                >School Category<span class="required"
                                  >*</span
                                ></label
                              >
                              <datalist id="schcate">
                                <option value="CBSE">CBSE</option>
                                <option value="International"
                                  >International</option
                                >
                                <option value="ICSE">ICSE</option>
                                <option value="Government">Government</option>
                                <option value="Government Aided"
                                  >Government Aided
                                </option>
                              </datalist>
                            </span>
                          </div>
                        </div>
                        <div class="form-row mt-4">
                          <div class="form-group input-group col-sm-6 ">
                            <span class="web-has-float-label">
                              <input
                                list="forclass"
                                value=""
                                class="form-control web-form-input"
                                id="forclassid"
                                placeholder="For Class"
                                required="required"
                              />
                              <label for="forclassid"
                                >For Class<span class="required">*</span></label
                              >
                              <datalist id="forclass">
                                <option value="I STD">I STD</option>
                                <option value="II STD">II STD</option>
                                <option value="III STD">III STD</option>
                              </datalist>
                            </span>
                          </div>
                          <div class="form-group input-group col-sm-6 pr-md-3">
                            <span class="web-has-float-label">
                              <input
                                list="seldist"
                                value=""
                                class="form-control web-form-input"
                                id="seldistid"
                                placeholder="Select Location"
                                required="required"
                              />
                              <label for="seldistid"
                                >Select Location<span class="required"
                                  >*</span
                                ></label
                              >
                              <datalist id="seldist">
                                <option value="Chennai">Chennai</option>
                                <option value="Coimbatore">Coimbatore</option>
                              </datalist>
                            </span>
                          </div>
                        </div>

                        <button type="submit" class="web-custbutton mt-3">
                          Search</button
                        ><button
                          @click="closeSearch()"
                          class="web-cancelbutton mt-3 ml-2"
                        >
                          Cancel
                        </button>
                      </form>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ViSpinner from "../components/Common/ViSpinner";
import ViService from "../services/ViService";
import errorLog from "../utils/errorLog";
import secureUI from "../utils/secureUI";
import { eventBus } from ".././event-bus";

export default {
  name: "vi-header",
  components: {
    ViSpinner,
  },
  data() {
    return {
      sname: null,
      viLoader: null,
      slocation: null,
      scategory: null,
      serviceError: null,
      selectOurService: null,
      servicesList: [
        'WEBSITE & ONLINE ADMISSION ENROLLMENT',
        'LIST YOUR SCHOOLS ONLINE FOR WIDER REACH',
        'PARENT PORTAL',
        'ADMISSION MANAGEMENT',
        'FEE MANAGEMENT',
        'ALERTS & NOTIFICATIONS'
      ]
    };
  },
  computed: {
    ourServiceActive() {
      return this.$store.getters.getOurServiceActiveLink;
    },
    hasUserContext() {
      return localStorage.getItem('user') ? false : true
    }
  },
  methods: {
    async redirectRoute(vipath) {
      this.$store.dispatch('setOurServiceActiveLink', '');
      this.selectOurService = null
      eventBus.$emit("button-action-common", vipath);
    },
     async viewOurServices(ss,data) {
      this.$store.dispatch('setOurServiceActiveLink', data);
      eventBus.$emit("button-action-common", '/#services');
      eventBus.$emit("callOurServices", data);
    
    },
    navigateRoute(path){
      this.selectOurService = null
      if (this.$route.path !== path) this.$router.push({ path: path });

    },
    reload(){
      location.reload();
    },
    clear() {
      this.$toasted.clear();
      this.sname = null;
      this.scategory = null;
      this.slocation = null;
      this.serviceError = null;
    },
    submitSearch() {
      this.$toasted.clear();
      
      let requestBody = {
        schoolName: this.sname,
        category: this.scategory,
        city: this.slocation,
      };
      this.viLoader = true;
      ViService.viPost("/app/school", requestBody)
        .then((res) => {
          this.viLoader = null;
          if (res.isSuccess) {
            
            let data = secureUI.secureGet(res.data);
            if (data && data.length > 0) {
              this.closeSearch();
              this.$store.dispatch("setSchoolList", data);
              this.$router.push({
                name: "schools",
              });
            } else {
              this.$toasted.error("Records not found");
            }
          } else {
            this.$toasted.error(res.message);
          }
        })
        .catch((e) => {
          this.viLoader = null;
          let eData = errorLog.apiErrorLog(e);
          this.$toasted.error(eData);
          console.log(eData);
        });
    },
    reset() {
      this.clear();
    },
   
    openSearch() {
      document.getElementById("myOverlay").style.display = "block";
    },
    closeSearch() {
      document.getElementById("myOverlay").style.display = "none";
    },
  },
};
</script>

<style lang="scss" scoped></style>